import { render, staticRenderFns } from "./internship.vue?vue&type=template&id=6a17ede5&scoped=true"
import script from "./internship.vue?vue&type=script&lang=ts"
export * from "./internship.vue?vue&type=script&lang=ts"
import style0 from "./internship.vue?vue&type=style&index=0&id=6a17ede5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17ede5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeading: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-heading.vue').default,DataFilter: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/data-filter.vue').default,TechPostList: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/tech-post/list.vue').default,BtnDirection: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-direction.vue').default})
